import { Injector } from "@dojo/framework/core/Injector";
import { ActionCreatorsMapObject } from "redux";
import { IBrowserType } from "../interfaces/model/index";

/**
 * API Action interface
 */
export interface IApiSet {
    canvasContainerEl: HTMLElement;
    canvasApi: ActionCreatorsMapObject;
    clipboardApi: ActionCreatorsMapObject;
    guideApi: ActionCreatorsMapObject;
    pageApi: ActionCreatorsMapObject;
    selectionApi: ActionCreatorsMapObject;
}

/**
 * Redux actions API injector
 */
export class ApiContext extends Injector {
	private _api: IApiSet;
	private _browserType: IBrowserType;
	private _dontDownloadImages: boolean;
	private _emitImagesLoadedEvent: boolean;

	constructor(api: IApiSet, browserType: any, dontDownloadImages: boolean, emitImagesLoadedEvent: boolean) {
		super({ api });
		this._api = api;
		this._browserType = browserType;
		this._dontDownloadImages = dontDownloadImages;
		this._emitImagesLoadedEvent = emitImagesLoadedEvent;
	}

	get api(): IApiSet {
		return this._api;
	}

	public get(): ApiContext {
		return this;
	}

	get browserType(): any {
		return this._browserType;
	}

	get dontDownloadImages(): any {
		return this._dontDownloadImages;
	}

	get emitImagesLoadedEvent(): any {
		return this._emitImagesLoadedEvent;
	}
}
